import React from 'react';
import styles from './RadioButton.module.css';


export class RadioButton extends React.Component {

    onClick() {
        if (!this.props.disabled && this.props.onClick) {
            this.props.onClick(!this.props.checked);
        }
    }

    render() {
        let cls;
        cls = styles.radio_wrapper;

        if (this.props.className) {
            cls += ' ' + this.props.className;
        }

        return (
            <span className={cls} onClick={() => this.onClick()}>
                {this.props.selected &&
                    <input type='radio' defaultChecked={true} disabled={this.props.disabled} />
                }
                {!this.props.selected &&
                    <input type='radio' disabled={this.props.disabled} />
                }
                {this.props.label &&
                    <span className={styles.radio_label}>{this.props.label}</span>
                }
            </span>



        );
    }
}

